import { GeoInfoService } from '@account/services/geo-info-service';
import { CommonModule, CurrencyPipe, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localeEs from '@angular/common/locales/es-CO';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';

import { RedirectionComponent } from '@shared/components/redirection/redirection.component';
import { HandleErrorInterceptor } from '@shared/interceptors/handleError.interceptor';
import { LoaderService } from '@shared/services/loader/loader.service';
import { RedirectionService } from '@shared/services/redirection.service';
import { SharedModule } from '@shared/shared.module';

import { environment } from '@environments/environment';

import { AuthGuard } from '@auth/guards/auth.guard';
import { AuthInterceptor } from '@auth/interceptors/auth.interceptor';
import { RequestIdInterceptor } from '@auth/interceptors/request-id.interceptor';
import { TokenInterceptor } from '@auth/interceptors/token.interceptor';
import { CoreModule } from '@core/core.module';
import { HomeModule } from '@home/home.module';

import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { CookieService } from 'ngx-cookie-service';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AppComponent } from './app.component';

registerLocaleData(localeEs, 'es-CO'); // DA FORMATO A LOS PIPE EN LOS SERVICIOS y proporciona la zona horaria correcta
const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'redirect',
    component: RedirectionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then((m) => m.AccountModule),
  },
  { path: '**', redirectTo: '/login', pathMatch: 'full' },
];

export function minlengthValidationMessage(err, field) {
  return `Should have atleast ${field.templateOptions.minLength} characters`;
}

export function maxlengthValidationMessage(err, field) {
  return `This value should be less than ${field.templateOptions.maxLength} characters`;
}

export function patternlengthValidationMessage(err, field) {
  return `message: ${field.validation.messages.pattern}`;
}

export function minValidationMessage(err, field) {
  return `This value should be more than ${field.templateOptions.min}`;
}

export function maxValidationMessage(err, field) {
  return `This value should be less than ${field.templateOptions.max}`;
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule.forRoot(routes),
    BrowserAnimationsModule,
    NgxPermissionsModule.forRoot(),
    HomeModule,
    SharedModule,
    BackButtonDisableModule.forRoot(),
    // TooltipModule,
    MatTooltipModule,
    CoreModule,
  ],
  providers: [
    CookieService,
    LoaderService,
    RedirectionService,
    GeoInfoService,
    CurrencyPipe,
    { provide: LOCALE_ID, useValue: 'es-CO' }, // DA FORMATO A LOS PIPE EN EL HTML
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HandleErrorInterceptor,
      multi: true,
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchaV3SiteKey,
    },
    { provide: HTTP_INTERCEPTORS, useClass: RequestIdInterceptor, multi: true },
    GeoInfoService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
